import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import AppointmentFlow from 'components/Flows/AppointmentFlows/AppointmentFlows';
import AppointmentAnalysisDrawer from 'components/Analyses/AppointmentAnalyses/Drawer/Drawer';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const AppointmentFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <AppointmentAnalysisDrawer />
      <AppointmentFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <AppointmentFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);